<template>
  <div class="conversation">
    <div class="top">
      <div class="top-title">
        <div>成员</div>
        <div class="ft24 c9" @click='goLookMember'>查看全部成员 > </div>
      </div>
      <div class="scroll">
        <div class="top-content" :style="tableStyle">
          <div class="member" v-for="(member, index) in memberList" :key="index">
            <img class="member-img" :src='member.avatarUrl'></img>
            <div class="member-name">{{member.nickName}}</div>
          </div>
          <div class="member" @click='addMember' v-show="userView == 2">
            <img class="member-img" src='https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/imgs/icons/add.png'></img>
            <div class="member-name" style="color:#1261dc">添加</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mid">
      <div class="mid-item">
        <div>类型</div>
        <div class="c9">{{detailInfo.chatType == 1 ? '群聊': '单聊'}}</div>
      </div>
      <div class="mid-item">
        <div>名称</div>
        <div class="c9 df" @click='openName'>
          <div>{{detailInfo.name}}</div>
          <img class="arrow" v-show="detailInfo.chatType == 1" :src='arrowImg'></img>
        </div>
      </div>
      <div class="mid-item">
        <div>公告</div>
      </div>
      <div class="mid-item" style="height:inherit;padding:10px">
        <div class="c9">
          {{newNotice}}
        </div>
        <div class="c9 df" @click='goNotice'>
          <img class="arrow" :src='arrowImg'></img>
        </div>
      </div>
      <div class="mid-item">
        <div>置顶</div>
        <div class="c9 df">
           <van-switch style="transform:scale(.5)"  :value='detailInfo.priorityOfRoom == 1'  @change="switchTop" />
        </div>
      </div>
      <div class="mid-item" style="border:0">
        <div>消息免打扰</div>
        <div class="c9 df">
           <van-switch style="transform:scale(.5)" :value='detailInfo.messageNoticeType == 1' @change="switchTrouble" />
        </div>
      </div>
    </div>
    <div class="bot">
      <div class="bot-btn" @click='openEmpty'>清空消息</div>
      <div class="bot-btn" style="border-top:0" v-show="detailInfo.chatType == 1" @click='openQuit'>退出并返回</div>
    </div>
    <!-- <uni-popup ref="emptyPopup" type="dialog">
      <uni-popup-dialog 
        mode="base" 
        content='确认清空消息？' 
        type="warn" 
        :duration="2000" 
        :before-close="true" 
        @close="close" 
        @confirm="confirmEmpty"
        >
      </uni-popup-dialog>
    </uni-popup>
    <uni-popup ref="quitPopup" type="dialog">
      <uni-popup-dialog 
        mode="base" 
        content='确认退出该会话？' 
        type="warn" 
        :duration="2000" 
        :before-close="true" 
        @close="close" 
        @confirm="confirmQuit"
        >
      </uni-popup-dialog>
    </uni-popup>
    <uni-popup ref="namePopup" type="dialog">
      <uni-popup-dialog 
        mode="input"
        message="修改" 
        :duration="2000"
        :value='detailInfo.name'
        @close='close'
        @confirm='confirmName'
        :before-close="true" 
      ></uni-popup-dialog>
    </uni-popup> -->
    <ltt-modal
      ref="emptyPopup"
      :isShowCancelButton='true'
      @confirm='confirmEmpty'
    >
      <div style="text-align:center;color:#999">确认清空消息？</div>
    </ltt-modal>
    <ltt-modal
      ref="quitPopup"
      :isShowCancelButton='true'
      @confirm='confirmQuit'
    >
      <div style="text-align:center;color:#999">确认退出该会话？</div>
    </ltt-modal>
     <ltt-modal
      ref="namePopup"
      :isShowCancelButton='true'
      @confirm='confirmName'
    >
      <van-field v-model="name"/>
    </ltt-modal>
  </div>
</template>

<script>
import  {getChatSessionDetails, modifyChatSessionDetails, signOutChatRoom, clearChatMessage} from '@/api/seller'
import { Switch, Toast, Dialog, Field} from 'vant';
import LttModal from '../../components/ltt-modal.vue'
export default {
  data() {
    return {
      memberList:[],
      query: {},
      detailInfo: {

      },
      name: '',
    }
  },
  computed: {
    tableStyle() {
      const len = this.memberList.length + 1
      const width = `${len * 60 }px`
      return `width: ${width}`
    },
    arrowImg(){
      return this.$store.state.arrowImg
    },
    newNotice() {
      return this.$store.state.seller.newNotice
    },
    userView() {
      return 0
    },
  },
  mounted(opt) {
    this.query = this.$route.query || {}
    this.getChatSessionDetails()
  },
  methods: {
    /** 添加成员 */
    addMember() {
    
     this.$nRouter.push('/pages/seller/chat/add-member', this.query)
    },
    /** 清空弹窗 */
    openEmpty() {
      this.$refs.emptyPopup.open()
    },
    close() {
      this.$refs.emptyPopup.close()
      this.$refs.quitPopup.close()
      this.$refs.namePopup.close()

    },
    /** 确认清除 */
    confirmEmpty() {
      this.clearChatMessage()

    },
    openQuit() {
      this.$refs.quitPopup.open()
    },
    // 确认退出
    async confirmQuit() {
      this.close()
     
      const params = {
        ...this.query
      }
      await signOutChatRoom(params)
      Toast('操作成功')
      setTimeout(() => {
        this.$nRouter.back(2)
      }, 1000)
    },
    // 去往设置公告
    goNotice() {
      this.$router.push({name: 'chatNotice', query: this.query})
    },
    // 查看全部成员
    goLookMember() {
      this.$router.push({name: 'lookMember', query: this.query})
    },
    /** 获取会话详情 */
    async getChatSessionDetails() {
      const params = {
        ...this.query
      }
      const res = await getChatSessionDetails(params)
      const { detail } = res.mdata
      this.memberList = detail.chatMembers
      this.detailInfo = detail
      this.$store.commit('seller/setNotice', detail.notice || '')
      this.$forceUpdate()
    },
    // 打开名称
    openName() {
       // 单聊不允许修改
      if(this.detailInfo.chatType == 0) {
        return
      }
      this.name = this.detailInfo.name
      this.$refs.namePopup.open()
    },
    confirmName(name) {
      
      this.modifyChatSessionDetails({name: this.name})
    },
    // 置顶
    switchTop(e) {
      this.detailInfo.priorityOfRoom = e ? 1 : 0
      const priorityOfRoom =  Number(e)
  
      this.modifyChatSessionDetails({priorityOfRoom})
    },
    // 免打扰
    switchTrouble(e) {
     
      this.detailInfo.messageNoticeType = e ? 1 : 0
      const messageNoticeType = Number(e)
      this.modifyChatSessionDetails({messageNoticeType})
    },
    async modifyChatSessionDetails(paramsInfo) {
      const params = {
        ...this.query,
        ...paramsInfo,
      }
      try {
        await modifyChatSessionDetails(params)
        this.close()
        Toast('操作成功')
      } catch (error) {
      } finally {
        this.getChatSessionDetails()
      }
      
    },
    // 清空消息
    async clearChatMessage() {
      const params = {
         ...this.query
      }
      const res = await clearChatMessage(params)
      this.$store.commit('seller/setChatMessageList', [])
      this.close()
      Toast('操作成功')
    }
  },
  components: {
    'van-switch': Switch,
    LttModal,
  }
}
</script>

<style scoped lang='less'>
.conversation {
  font-size: 28px;
  color: #222;
  padding: 10px;
  padding-bottom: 40px;
  .top {
    border: 1px solid #e5e5e5;
    padding: 10px;
    border-radius: 20px;
    background: #fff;
    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    &-content {
      display: flex;
    }
    .member {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      width: 120px;
      &-img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }
      &-name {
        font-size: 24px;
        text-align: center;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        width: 100%;
      }
    }
  }
  .mid {
    border: 1px solid #e5e5e5;
    padding: 10px;
    border-radius: 10px;
    margin-top: 20px;
    background: #fff;
    .arrow {
      width: 40px;
      height: 40px;
    }
    &-item {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      height: 70px;
    }
  }
  .bot {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    background: #fff;
    &-btn {
      border: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: center;
      color: red;
      height: 80px;
    }
  }
}
.c9 {
  color: #999;
}
.ft24 {
  font-size: 24px;
}
.scroll {
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
}
.df {
  display: flex;
  align-items: center;
}
</style>
